import React from 'react'

const VerticalEmailSection = () => {
  return (
    <div className='xl:-rotate-90 xl:fixed xl:left-[-235px] xl:top-[390px]'>
      <div className="flex items-center space-x-5 justify-center">
        <div className="h-0.5 w-32 bg-lightPurple"></div>
        <p className="font-Poppins text-darkPurple">contact.adityamall@gmail.com</p>
        <div className="h-0.5 w-32 bg-lightPurple"></div>
      </div>
    </div>
  );
}

export default VerticalEmailSection